(() => {
  if (window.rjMobileParentBound) return;
  window.rjMobileParentBound = true;
  const selector = '#NavDrawer .rj-mobile-parent';
  const toggleFor = (button) => {
    const row = button.closest('.mobile-nav__has-sublist');
    const controls = row && row.querySelector('.mobile-nav__toggle');
    if (!controls) return null;
    return Array.from(controls.querySelectorAll('button')).find(control => control.getClientRects().length && getComputedStyle(control).visibility !== 'hidden');
  };
  const sync = () => document.querySelectorAll(selector).forEach(button => {
    const toggle = toggleFor(button);
    if (toggle) button.setAttribute('aria-expanded', String(toggle.classList.contains('mobile-nav__toggle-close')));
  });
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (!button) return;
    const toggle = toggleFor(button);
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    toggle.click();
    requestAnimationFrame(sync);
  }, true);
  const observe = () => {
    const drawer = document.getElementById('NavDrawer');
    if (!drawer || drawer.dataset.rjParentObserved) return;
    drawer.dataset.rjParentObserved = 'true';
    new MutationObserver(sync).observe(drawer, {subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
